import Box from '@talkdesk/cobalt-react-box'
import Flex from '@talkdesk/cobalt-react-flex'
import TalkdeskFooter from '../../components/TalkdeskFooter'
import TalkdeskNavbar from '../../components/TalkdeskNavbar'
import styles from './Base.module.css'

const Base = (props) => {
  return (
    <Flex
      direction='column'
      alignY='space-between'
      style={{ minHeight: '100vh' }}
    >
      <TalkdeskNavbar
        brandingSettings={props.brandingSettings}
        showReturnButton={props.showReturnButton}
      />
      <Flex width='100%' alignX='center' alignY='center'>
        <Box paddingX={4} paddingY={6} className={styles.containerWidth}>
          {props.children}
        </Box>
      </Flex>
      <TalkdeskFooter
        brandingSettings={props.brandingSettings}
        showGoogleFooterLink={props.showGoogleFooterLink}
      />
    </Flex>
  )
}

export default Base
